import React, { useState, useEffect } from "react";
import { getOneCategory } from "../../redux/actions/subcategoryAction";
import { createProduct } from "../../redux/actions/productsAction";
import notify from "./../../hook/useNotifaction";
import { useSelector, useDispatch } from "react-redux";
import { getAllCategory } from "../../redux/actions/categoryAction";
import { getAllBrand } from "./../../redux/actions/brandAction";
import avatar from "../../images/avatar.png";

const AdminAddProductsHook = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCategory());
    dispatch(getAllBrand());
  }, []);
  //get last catgeory state from redux
  const category = useSelector((state) => state.allCategory.category);
  //get last brand state from redux
  const brand = useSelector((state) => state.allBrand.brand);

  //get last sub cat state from redux
  const subCat = useSelector((state) => state.subCategory.subcategory);

  const onSelect = (selectedList) => {
    setSeletedSubID(selectedList);
  };
  const onRemove = (selectedList) => {
    setSeletedSubID(selectedList);
  };

  const [options, setOptions] = useState([]);

  //values images products
  const [images, setImages] = useState({});
  //values state
  const [prodName, setProdName] = useState("");
  const [description, setDescription] = useState([{ key: "", value: "" }]);

  const [priceBefore, setPriceBefore] = useState(0);
  const [priceAftr, setPriceAftr] = useState(0);
  const [qty, setQty] = useState("الكمية المتاحة");
  const [CatID, setCatID] = useState("");
  const [BrandID, SetBrandID] = useState("");
  const [subCatID, setSubCatID] = useState([]);
  const [seletedSubID, setSeletedSubID] = useState([]);
  const [loading, setLoading] = useState(true);

  //////
  const [img, setImg] = useState(avatar);
  const [selectedFile, setSelectedFile] = useState(null);
  //////
  //to change name state
  const onChangeProdName = (event) => {
    event.persist();
    setProdName(event.target.value);
  };
  //to change name state
  const onChangeDesName = (index, field, value) => {
    const updatedDescription = [...description];
    updatedDescription[index][field] = value;
    setDescription(updatedDescription);
  };
  // description
  const addRow = () => {
    setDescription([...description, { key: "", value: "" }]);
  };
  // Remove a row description
  const removeRow = (index) => {
    const updatedDescription = description.filter((_, i) => i !== index);
    setDescription(updatedDescription);
  };
  //to change name state
  const onChangePriceBefor = (event) => {
    event.persist();

    setPriceBefore(+event.target.value);
  };
  //to change name state
  const onChangePriceAfter = (event) => {
    event.persist();
    setPriceAftr(+event.target.value);
  }; //to change name state
  const onChangeQty = (event) => {
    event.persist();
    setQty(+event.target.value);
  };
  const onChangeColor = (event) => {
    event.persist();
    setShowColor(!showColor);
  };

  //to show hide color picker
  const [showColor, setShowColor] = useState(false);
  //to store all pick color
  const [colors, setColors] = useState([]);
  //when choose new color
  const handelChangeComplete = (color) => {
    setColors([...colors, color.hex]);
    setShowColor(!showColor);
  };
  const removeColor = (color) => {
    const newColor = colors.filter((e) => e !== color);
    setColors(newColor);
  };

  //when selet category store id
  const onSeletCategory = async (e) => {
    if (e.target.value !== 0) {
      await dispatch(getOneCategory(e.target.value));
    }
    setCatID(e.target.value);
  };
  useEffect(() => {
    if (CatID !== 0) {
      if (subCat.data) {
        setOptions(subCat.data);
      }
    } else setOptions([]);
  }, [CatID]);

  //when selet brand store id
  const onSeletBrand = (e) => {
    SetBrandID(e.target.value);
  };

  //to convert base 64 to file
  //   function dataURLtoFile(dataurl, filename) {
  //     var arr = dataurl.split(","),
  //       mime = arr[0].match(/:(.*?);/)[1],
  //       bstr = atob(arr[1]),
  //       n = bstr.length,
  //       u8arr = new Uint8Array(n);

  //     while (n--) {
  //       u8arr[n] = bstr.charCodeAt(n);
  //     }

  //     return new File([u8arr], filename, { type: mime });
  //   }

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImg(URL.createObjectURL(event.target.files[0]));
      setSelectedFile(event.target.files[0]);
    }
  };

  const product = useSelector((state) => state.allproducts.products);

  const checkIsComplate = () =>
    prodName.length > 3 &&
    qty > 0 &&
    priceBefore > 0 &&
    description.length > 0 &&
    CatID.length > 8 &&
    colors.length > 0 &&
    BrandID.length > 8 &&
    selectedFile;

  //to save data
  const handelSubmit = async (e) => {
    e.preventDefault();
    if (checkIsComplate() === false) {
      notify("من فضلك اكمل البيانات", "warn");
      return;
    }

    //   //convert base 64 image to file
    //   // const imgCover = dataURLtoFile(images[0], Math.random() + ".png");
    //   // //convert array of base 64 image to file
    //   // const itemImages = Array.from(Array(Object.keys(images).length).keys()).map(
    //   //   (item, index) => {
    //   //     return dataURLtoFile(images[index], Math.random() + ".png");
    //   //   }
    //   // );

    const formData = new FormData();
    formData.append("title", prodName);
    formData.append("quantity", qty);
    formData.append("price", priceBefore);
    formData.append("priceAfterDiscount", priceAftr);
    formData.append("category", CatID);
    formData.append("brand", BrandID);
    formData.append("image", selectedFile);
    formData.append("colors", JSON.stringify(colors));
    formData.append("description", JSON.stringify(description));
    formData.append(
      "subCategory",
      JSON.stringify(seletedSubID.map((item) => item._id))
    );

    setTimeout(async () => {
      setLoading(true);
      await dispatch(createProduct(formData));
      setLoading(false);
    }, 1000);
  };

  // //get create meesage

  useEffect(() => {
    if (loading === false) {
      setCatID(0);
      setColors([]);
      setImages([]);
      setProdName("");
      setDescription([{ key: "", value: "" }]);
      setPriceBefore("السعر قبل الخصم");
      setPriceAftr("السعر بعد الخصم");
      setQty("الكمية المتاحة");
      SetBrandID(0);
      setSeletedSubID([]);
      setTimeout(() => setLoading(true), 1500);
      if (product) {
        if (product.status === 201 || product.status === 200) {
          notify("تم الاضافة بنجاح", "success");
        } else {
          notify("هناك مشكله", "error");
        }
      }
    }
  }, [loading]);

  return [
    onChangeQty,
    onChangeColor,
    onChangePriceAfter,
    onChangePriceBefor,
    onChangeProdName,
    showColor,
    category,
    brand,
    priceAftr,
    images,
    setImages,
    onSelect,
    onRemove,
    options,
    handelChangeComplete,
    removeColor,
    onSeletCategory,
    handelSubmit,
    onSeletBrand,
    colors,
    priceBefore,
    qty,
    prodName,
    img,
    onImageChange,
    description,
    onChangeDesName,
    addRow,
    removeRow,
    checkIsComplate,
  ];
};

export default AdminAddProductsHook;
